module.exports = __webpack_public_path__ + "static/MizuhoMiyagawa-6d0ba12bd8f011d0c78e9e773abe3965.jpg";